<template>
    <div class="booking-insurance">

        <throbber-overlay v-if="busy"></throbber-overlay>

        <div class="error" v-if="!valid">
            Invalid or not enough details provided to list insurance options.
        </div>
        <div class="coverage-options" v-else>

            <input type="hidden" value="" name="coverage[0]">
            <input type="hidden" value="" name="coverage[1]">
            <input type="hidden" value="" name="coverage[2]">
            <input type="hidden" value="" name="coverage[3]">
            <input type="hidden" value="" name="coverage[4]">
            <input type="hidden" value="" name="coverage[5]">
            <input type="hidden" value="" name="coverage[6]">
            <input type="hidden" value="" name="coverage[7]">
            <input type="hidden" value="" name="coverage[8]">
            <input type="hidden" value="" name="coverage[9]">
            <input type="hidden" value="" name="coverage[10]">
            <input type="hidden" value="" name="coverage[11]">

            <div class="busy" v-if="busy">
                Fetching coverage options...
            </div>
            <div v-for="(option, index) in coverageOptions" v-else>
                <label>
                    <input type="checkbox" :value="option.code" v-bind:name="'coverage[' + index + ']'"
                           v-bind:checked="checked[option.code]"
                           v-model="checkedOptions"
                           @change="$_changedCoverage"
                    >
                    <strong>{{option.title}}</strong>
                    at
                    <span class="charge">${{option.calculation.UnitCharge}}</span> per <span class="charge-unit">{{option.calculation.UnitName}}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .booking-insurance {
        position: relative;

        .busy {
            margin: 2em 0;
        }
    }
</style>


<script>
    const Api = require('../../../../global/js/modules/api');

    const ThrobberOverlay = require('./ThrobberOverlay');

    const events = {
        startedLoading: 'booking-insurance-selector:started-loading',
        finishedLoading: 'booking-insurance-selector:finished-loading',
        changedCoverage: 'booking-instance-selector:changed-coverage',
    };

    function _dispatchDomEvent($el, eventName, data = null) {
        let eventData = data === null
            ? {}
            : {detail: data};

        eventData.bubbles = true;

        /*let event = data === null
            ? new Event(eventName, eventData)
            : new CustomEvent(eventName, eventData);*/
        let event = new CustomEvent(eventName, eventData);

        $el.dispatchEvent(event);
    }

    function _updateActionStack(context, newAction = true) {
        let current = context.currentActions;

        context.currentActions += newAction ? 1 : -1;
        context.currentActions = Math.max(context.currentActions, 0);

        if (current > 0 && context.currentActions === 0) {
            _dispatchDomEvent(context.$el, events.finishedLoading);
        }
        else if(current === 0 && context.currentActions > 0) {
            _dispatchDomEvent(context.$el, events.startedLoading);
        }
    }


    function _getInsuranceOptions(context) {
        _updateActionStack(context);
        Api.remote.getInsuranceOptions({
            location_slugs: [context.locationSlug], vehicle_slug: context.vehicleSlug,
            from: context.from, to: context.to,
            _token: context.csrfToken,
            discountCode: context.discountCode,
            promotionalCode: context.promotionalCode,
            rateCode: context.rateCode,
            voucherNumber: context.voucherNumber,
        })
            .then(options => {
                let newOptions = [];

                options = Object.entries(options);

                if (options.length > 0) {
                    //get the first... there should only be 1 location at this stage...
                    options = options[0][1];

                    for (let option of Object.entries(options)) {
                        newOptions.push(option[1]);
                        if (context.selected.indexOf(option[1].code.toString()) >= 0) {
                            //context.checked[option[1].code] = true;
                            context.checkedOptions.push(option[1].code);
                        }
                    }
                }


                context.coverageOptions = newOptions;
            }, error => {
                console.error('There was an error for insurance!', error);
            })
            .finally(() => {
                _updateActionStack(context, false);
            });
    }

    export default {  components: {
            ThrobberOverlay
        },
        props: {
            vehicleSlug: {
                type: String,
                required: true,
            },
            locationSlug: {
                type: String,
                required: true,
            },
            from: {
                type: String,
                required: true,
            },
            to: {
                type: String,
                required: true,
            },
            discountCode: {
                type: String,
                default: '',
            },
            promotionalCode: {
                type: String,
                default: '',
            },
            rateCode: {
                type: String,
                default: '',
            },
            voucherNumber: {
                type: String,
                default: '',
            },
            selected: {
                type: Array,
                default: function () { return []; }
            },
            totalDays: {
                type: Number,
                default: 1,
            }
        },
        data: () => {
            return {
                currentActions: 0,
                coverageOptions: [],
                checked: {},
                checkedOptions: [],
            }
        },
        computed: {
            valid: function() {
                return (this.vehicleSlug && this.locationSlug &&
                        this.from && this.to)
                    ;
            },
            busy: function() {
                return this.currentActions > 0;
            },
            csrfToken: function() {
                let token = document.querySelector('[type="hidden"][name="_token"]');

                return token ? token.value : null;
            },
        },
        mounted() {
            if (!this.valid) {
                console.error('booking insurance fields not valid or not provided',
                    this.vehicleSlug,
                    this.locationSlug
                );
                return;
            }

            _getInsuranceOptions(this);

            //dispatch an initial event so that UIs can update...
            //@todo Push this out to a request from the external script...
            window.setTimeout(() => {
                this.$_changedCoverage();
            }, 1000);

        },
        methods: {
            $_changedCoverage: function() {
                let selectedCoverage = [], total = 0;
                for (let code of this.checkedOptions) {
                    for (let coverage of this.coverageOptions) {
                        if (coverage.code === code) {
                            selectedCoverage.push(coverage);
                            //@todo Check if API always returns a single day for coverage!!!
                            total += coverage.calculation.Quantity * coverage.calculation.UnitCharge * this.totalDays;
                        }
                    }
                }

                const data = {
                    totalAmount: total,
                    selectedCoverage,
                };

                _dispatchDomEvent(this.$el, events.changedCoverage, data);
            }
        }
    }
</script>
